import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app.component';
import { AppSettingsUrl } from './appSettings';
import { AnonModule } from './pages/anon/anon.module';
import { AuthGuard } from './services/authGuard.service';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ToastContainerDirective, ToastrModule } from 'ngx-toastr';
import { AlertsService, AsyncService, HubService, TranslationService } from './services';
import { AuthService } from './services/auth.service';
import { LocalStorageService } from './services/localStorage.service';
import { SessionStorageService } from './services/sessionStorage.service';

import { provideFirebaseApp, getApp, initializeApp } from '@angular/fire/app'; 

import {
	MAT_SNACK_BAR_DEFAULT_OPTIONS,
	MatSnackBarConfig,
	MatSnackBarModule,
} from '@angular/material/snack-bar';
import {
	MAT_TOOLTIP_DEFAULT_OPTIONS,
	MatTooltipDefaultOptions,
	MatTooltipModule
} from '@angular/material/tooltip';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireModule } from '@angular/fire/compat';

export const createTranslateLoader = (http: HttpClient) =>
	new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + AppSettingsUrl.version);

const firebasePushConfig = {
	apiKey: "AIzaSyBPOraF8N_fbYEvh8bsgMa1GRHJqSL8E0w",
	authDomain: "marktools-social.firebaseapp.com",
	projectId: "marktools-social",
	storageBucket: "marktools-social.firebasestorage.app",
	messagingSenderId: "485573135668",
	appId: "1:485573135668:web:00a3b89650366b191fa961"
  }; 
  
export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
	showDelay: 1200,
	hideDelay: null,
	touchendHideDelay: null,
	position: 'above'
};
export const myCustomSnackBarsDefaults: MatSnackBarConfig = {
	horizontalPosition: 'center',
	verticalPosition: 'top',
};

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		BrowserModule,
		RouterModule.forRoot([

			{
				path: 'admin', canActivate: [AuthGuard],
				loadChildren: () => import('./pages/admin/admin.module').then((m) => m.AdminModule)
			},
			{
				path: 'user', canActivate: [AuthGuard],
				loadChildren: () => import('./pages/user/user.module').then((m) => m.UserModule)
			},
			{
				path: 'auth', canActivate: [AuthGuard],
				loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule)
			},
			{
				path: ':lang',
				loadChildren: () => import('./pages/anon/anon.module').then((m) => m.AnonModule)
			},
			{ path: 'r/:refid', loadChildren: () => import('./pages/anon/anon.module').then((m) => m.AnonModule) },
			{ path: '**', redirectTo: AppSettingsUrl.appDefaultUrl },
		], {
			enableTracing: false,
			scrollPositionRestoration: 'enabled',
			anchorScrolling: 'enabled',
		}),
		HttpClientModule,
		BrowserAnimationsModule,
		MatSnackBarModule,
		ToastrModule.forRoot(),
		MatTooltipModule,
		AnonModule,
		TranslateModule.forRoot({
			defaultLanguage: 'en',
			loader: {
				provide: TranslateLoader,
				useFactory: createTranslateLoader,
				deps: [HttpClient]
			}
		}),
		ServiceWorkerModule.register('ngsw-worker.js', {
			enabled: !isDevMode(),
			// Register the ServiceWorker as soon as the application is stable
			// or after 30 seconds (whichever comes first).
			registrationStrategy: 'registerWhenStable:30000'
		}),
		AngularFireModule.initializeApp(firebasePushConfig),
		AngularFireMessagingModule
	],
	providers: [
		AuthGuard,
		AuthService,
		LocalStorageService,
		SessionStorageService,
		AsyncService,
		HubService,
		TranslationService,
		{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults },
		{ provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: myCustomSnackBarsDefaults },
		AlertsService
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
